export function formatNumber(phoneNumber) {
    if (!phoneNumber || phoneNumber.trim() === '') {
        return null;
    }
    return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');
}

export function formatDate(date) {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

